import type { GradeCategory } from "@core/grades/types";
import { URLS } from "@core/shared/utils";

const palettes = [
  {
    surface:
      "from-violet-100 via-fuchsia-50 to-white dark:from-violet-950 dark:via-fuchsia-950/40 dark:to-slate-950",
    accent: "text-violet-600 dark:text-violet-300",
  },
  {
    surface:
      "from-cyan-100 via-sky-50 to-white dark:from-cyan-950 dark:via-sky-950/40 dark:to-slate-950",
    accent: "text-cyan-600 dark:text-cyan-300",
  },
  {
    surface:
      "from-amber-100 via-orange-50 to-white dark:from-amber-950 dark:via-orange-950/40 dark:to-slate-950",
    accent: "text-orange-600 dark:text-orange-300",
  },
] as const;

export function useCategoryFeedTile(category: GradeCategory, index: number) {
  const numericId = Number(category.id);
  const palette =
    palettes[
      Number.isFinite(numericId)
        ? Math.abs(numericId) % palettes.length
        : index % palettes.length
    ];

  return {
    href: URLS.grades.viewCategory(category),
    hasImage: Boolean(category.image?.url),
    image: category.image?.url,
    lessonCount: category.lessons?.length || category.total?.lessons || 0,
    sequence: index + 1,
    ...palette,
  };
}
